import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { actionCreators } from '@/store/Help'
import Name from '@/components/Name'
import { Col, Row, Label, FormGroup } from 'reactstrap'
import Resx from '@/components/Resx'
import { Button } from '@/components/button'
import Icon from '@/components/Icon'
import { RichTextEditor } from '@/components/richTextEditor'
import { withPermissions } from '@/decorators/withPermissions'
import { getStore } from '@/store'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import { dialogTypes } from '@/dialogs'

function mapStateToProps (state, ownProps) {
  const path = ownProps.match.path
  state = state.help
  const data = state.pages[path]
  const editing = !!state.editing[path]
  const show = !!state.show[path]
  const saving = !!state.saving[path]
  return {
    path,
    editing,
    data,
    show,
    saving
  }
}

function showMessage (errorText) {
  getStore().dispatch(dialogActions.openDialog({
    dialogType: dialogTypes.alert,
    title: 'Common.Warning',
    content: errorText || 'Messages.TextContainsJavascript'
  }))
}

const mapDispatchToProps = {
  toggle: actionCreators.toggle,
  edit: actionCreators.edit,
  cancel: actionCreators.cancel,
  save: actionCreators.save
}

@withPermissions()
@withRouter
@connect(mapStateToProps, mapDispatchToProps)
class HelpBox extends React.Component {
  handleChange = prop => e => {
    const { path, change, data } = this.props
    change(path, { ...data, [prop]: e.target.value })
  }

  render () {
    const { path, show, editing, data, edit, save, saving, cancel, toggle, isGranted } = this.props

    if (!show) return null
    if (editing) {
      return (
        <div className='helpbox edit'>
          <button className='helpbox-close' onClick={() => toggle(path)}><Icon name='x' /></button>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label><Resx name='Common.Text' /></Label>
                <RichTextEditor value={data.text || ''} ref={ref => { this.textRef = ref }} />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label><Resx name='Common.LatinText' /></Label>
                <RichTextEditor value={data.latinText || ''} ref={ref => { this.latinTextRef = ref }} />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col>
              <Button
                color='success' size='sm' icon={saving ? 'loader bx-spin' : 'save'} disabled={saving}
                onClick={() => save(path, this.textRef.getValue(), this.latinTextRef.getValue(), showMessage)}>
                <Resx name='Common.Save' />
              </Button>
              &nbsp;
              <Button size='sm' onClick={() => cancel(path)} disabled={saving}><Resx name='Common.Cancel' /></Button>
            </Col>
          </Row>
        </div>
      )
    }
    const canEdit = isGranted('CanManageHelp') || isGranted('CanMangeHelpExternal')
    return (
      <div className='helpbox'>
        <button className='helpbox-close' onClick={() => toggle(path)}><Icon name='x' /></button>
        <div className='cms-text'><Name data={{ name: data.text, latinName: data.latinText }} isHtml /></div>
        <div className='mt-3'>
          {canEdit && <Button color='primary' size='sm' icon='edit' onClick={() => edit(path)}><Resx name='Common.Edit' /></Button>}
        </div>
      </div>
    )
  }
}

export {
  HelpBox
}



// WEBPACK FOOTER //
// ./src/components/help/helpBox.js